<p-panel header="Header"  [toggleable]="true" >
    <ng-template pTemplate="header">
        <p-button label="Click" icon="pi pi-plus" iconPos="left" class="panel-btn"></p-button>
        
    </ng-template>
    <ng-content></ng-content>
</p-panel>

<!--expandIcon="pi pi-chevron-circle-down" collapseIcon="pi pi-chevron-circle-up" html developer-->
